import fullpage from "./../components/fullpage4/dist/fullpage.js";
import Swiper from 'swiper';
import Pagination from 'swiper/modules/pagination/pagination';
import Autoplay from 'swiper/modules/autoplay/autoplay';
import FadeEffect from 'swiper/modules/effect-fade/effect-fade';
import CreativeEffect from 'swiper/modules/effect-creative/effect-creative'
import $ from 'jquery';

window.$ = window.jQuery = $;

export default class Sliders {
  constructor() {
    this.header = document.querySelector(".header");

    let header = this.header;

    if (window.innerWidth > 1366) {
      this.fullPageSlider = fullpage('#fullpage', {
        navigation: false,
        onLeave(anchor, index, nextIndex, direction, destination) {
          if (index.isLast === true) {
            header.classList.add("close");
          } else if (document.querySelector(".header.close")) {
            header.classList.remove("close");
          }
        }
      });
      $('.move-down').on('click', () => {
        this.fullPageSlider.moveSectionDown();
      });

      $('.move-to-contacts').on('click', () => {
        this.fullPageSlider.moveTo(4);
      });
    }

    if (window.innerWidth <= 1366) {
      this.handleHeaderAfterScroll(header);
    }
  }

  handleHeaderAfterScroll(header) {
    window.addEventListener("scroll", () => {
      let $footer = $('.footer')
      let wt = $(window).scrollTop();
      let wh = $(window).height();
      let et = $footer.offset().top;
      let eh = $footer.outerHeight();

      if (wt + wh >= et && wt + wh - eh * 2 <= et + (wh - eh)) {
        header.classList.add("close");
      } else {
        header.classList.remove("close");
      }
    });
  }
}
